<div *ngIf="isImage || wasImage">
  <div class="form-check form-switch">
    <input
      class="form-check-input"
      type="checkbox"
      role="switch"
      id="switchCheckChecked"
      checked
      (click)="switchImageToText()"
    />
    <label class="form-check-label" for="switchCheckChecked"
      >Upload image</label
    >
  </div>
</div>
<div *ngIf="!isImage || !isTranslator">
  <label for="quillEditor" class="mb-2 {{ type }} "
    ><span *ngIf="placeholder && placeholder !== ''">{{ placeholder }}</span>
    {{ canBeEmpty ? "(This element can be left empty)" : "" }}
  </label>
  <div
    [ngClass]="{
      row: isSubBlockDeletable,
      'justify-content-center': isSubBlockDeletable,
    }"
  >
    <quill-editor
      [disabled]="disabled"
      id="quillEditor"
      [attr.data-field-key]="blockId + '::' + variable"
      (mousedown)="$event.stopPropagation()"
      [modules]="modules"
      [formats]="formats"
      [placeholder]="options.placeholder"
      [theme]="options.theme"
      (onEditorCreated)="onEditorCreated($event)"
      (onContentChanged)="onContentChanged($event)"
      [(ngModel)]="inputData"
      [escape]="false"
      [tooltipDisabled]="!restrictContent"
      [pTooltip]="restrictedContentTooltip"
      tooltipPosition="top"
      [ngClass]="{
        'border-red': tooManyChars || hasForbiddenContent,
        'can-be-empty': canBeEmpty,
        'is-plain-text': isPlainText,
        'col-11': isSubBlockDeletable,
        'gy-2': !isSubBlockDeletable,
      }"
      *ngIf="!isImage"
    ></quill-editor>
    <div class="col-1" *ngIf="isSubBlockDeletable && !isImage">
      <a class="btn btn-sm" (click)="removeSubBlock()"
        ><i class="bi bi-trash-fill remove-sub-block-icon"></i
      ></a>
    </div>
  </div>

  <app-segment-select-v2
    *ngIf="type == 'action-link' && segmentSelectV2"
    (selectedSegmentChange)="selectedSegmentChanged($event)"
    [selectedSegment]="selectedSegmentFromString"
  ></app-segment-select-v2>
  <app-segment-dropdown
    *ngIf="type == 'action-link' && !segmentSelectV2"
    (selectedSegmentChange)="selectedSegmentChanged($event)"
    [selectedSegment]="selectedSegmentFromString"
  ></app-segment-dropdown>
  <!-- This will be used only if the block is an image -->
  <app-image-upload
    *ngIf="isImage"
    (imageSrcEvent)="updateInputData($event)"
    [imageSrc]="inputData"
    [blockId]="blockId"
  ></app-image-upload>
  <div *ngIf="isSubBlockDeletable && isImage" class="text-end mt-2">
    <a
      class="btn btn-sm d-inline-flex align-items-center gap-1"
      (click)="removeSubBlock()"
      >Remove this image<i class="bi bi-trash-fill remove-sub-block-icon"></i
    ></a>
  </div>
  <div>
    <p
      *ngIf="!isImage"
      [ngClass]="{
        'too-many-chars': tooManyChars,
        'mt-2': !isSubBlockDeletable,
        'mb-0': isPlainText,
      }"
    >
      Character counter: {{ length - 1 }} / {{ maxLength }}
    </p>
    <p *ngIf="!isImage && hasForbiddenContent" class="forbidden-content mb-0">
      Remove consecutive UPPERCASE text, emojis and special characters.
    </p>
  </div>
</div>